export const content = {
  breadcrumbRoot: 'Roaming & International',
  breadcrumbCurrent: 'International',
  breadcrumbMobile: 'Select another International country',
  pageTitle: (country: string) => `Using SMARTY in ${country}`,
}
